module.exports = __webpack_public_path__ + "static/img/img_form1_zh.106a878a.png";